import { Box } from '@mui/material'
import React from 'react'

import {
  cardHeader,
  warningCardHeader,
  whiteColor,
} from '@/styles/MuiComponentStyles'

const cardHeaderStyle = {
  display: 'inline-block',
  color: whiteColor,
  ...warningCardHeader,
  ...cardHeader,
}

type Props = {
  children?: React.ReactNode
}

export default function CardHeader({ children }: Readonly<Props>) {
  return (
    <Box sx={cardHeaderStyle} data-testid="card-header">
      {children}
    </Box>
  )
}
